export const columns = [
  {
    Header: '#',
    accessor: 'id',
  },
  {
    Header: 'URL',
    accessor: 'url',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Notification  Email',
    accessor: 'notification_emails',
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableGlobalFilter: true,
  },
];